import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

type Props = {
  size: 'small' | 'large';
  style?: React.CSSProperties;
};

export const Logo: React.FC<Props> = ({size, style}): JSX.Element | null => {
  if (size === 'small') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={30}
        height={30}
        fill='none'
        style={{...style}}
      >
        <path
          fill='#111'
          d='M.326 6.9C.663 3.337 3.384.881 6.94.47A70.846 70.846 0 0 1 15 0c3.055 0 5.826.213 8.06.47 3.556.411 6.277 2.867 6.614 6.43.188 1.99.326 4.631.326 8.1 0 3.469-.138 6.11-.326 8.1-.337 3.563-3.058 6.019-6.614 6.43-2.234.257-5.005.47-8.06.47a70.86 70.86 0 0 1-8.06-.47C3.384 29.118.663 26.662.326 23.1.138 21.11 0 18.469 0 15c0-3.469.138-6.11.326-8.1Z'
        />
        <path
          fill='#fff'
          d='M10.238 21.25V8.05h1.216l7.088 11.128V8.05h1.216v13.2h-1.216l-7.088-11.112V21.25h-1.216Z'
        />
      </svg>
    );
  }

  if (size === 'large') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={50}
        height={50}
        fill='none'
        style={{...style}}
      >
        <path
          fill='#111'
          d='M.989 7.757c.524-3.54 3.301-5.954 6.842-6.48A118.684 118.684 0 0 1 25 0c6.971 0 13.055.666 17.17 1.277 3.54.526 6.317 2.94 6.841 6.48.515 3.481.989 8.94.989 17.243 0 8.303-.474 13.762-.989 17.243-.524 3.54-3.301 5.954-6.842 6.48A118.688 118.688 0 0 1 25 50c-6.971 0-13.055-.666-17.17-1.277-3.54-.526-6.317-2.94-6.841-6.48C.474 38.762 0 33.303 0 25c0-8.302.474-13.761.989-17.243Z'
        />
        <path
          fill='#fff'
          d='M17.064 35.417v-22h2.026l11.814 18.546V13.417h2.026v22h-2.026L19.09 16.897v18.52h-2.026Z'
        />
      </svg>
    );
  }

  return null;
};
